import { useEffect, useState } from "react";
import styled from "styled-components";
import useSound from "use-sound";

const UseSound = ({ src, style = {} }) => {
  const { left, top, fontSize } = style;
  const [playAudio, setPlayAudio] = useState(false);
  const [play, { pause }] = useSound(src, {
    onend: () => {
      setPlayAudio(false);
    },
  });

  const handleClickAudio = () => {
    setPlayAudio(!playAudio);
  };

  useEffect(() => {
    playAudio ? play() : pause();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playAudio]);

  return (
    <IconWrapper
      fontSize={fontSize}
      left={left}
      top={top}
      onClick={handleClickAudio}
    >
      <i className="fa fa-volume-up" aria-hidden="true" />
    </IconWrapper>
  );
};

export default UseSound;

const IconWrapper = styled.div`
  position: absolute;
  top: ${(props) => (props.top ? props.top : "1px")};
  left: ${(props) => (props.left ? props.left : "5px")};
  cursor: pointer;
  &:hover {
    color: #00c2f3;
  }
  i {
    font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
  }
`;
